import { atom } from "jotai";

type NavigationHistoryState = {
	keys: string[];
	index: number;
};

const $navigationHistoryState = atom<NavigationHistoryState>({
	keys: [],
	index: -1,
});
$navigationHistoryState.debugLabel = "navigationHistoryState";

export const $navigationKeys = atom((get) => get($navigationHistoryState).keys);
$navigationKeys.debugLabel = "navigationKeys";

export const $navigationIndex = atom((get) => get($navigationHistoryState).index);
$navigationIndex.debugLabel = "navigationIndex";

export const $canGoBack = atom((get) => get($navigationHistoryState).index > 0);
$canGoBack.debugLabel = "canGoBack";

export const $canGoForward = atom((get) => {
	const state = get($navigationHistoryState);
	return state.index < state.keys.length - 1;
});
$canGoForward.debugLabel = "canGoForward";

export const $trackNavigation = atom(null, (get, set, key: string) => {
	const state = get($navigationHistoryState);
	const existingIndex = state.keys.indexOf(key);

	if (existingIndex !== -1) {
		set($navigationHistoryState, {
			...state,
			index: existingIndex,
		});
	} else {
		const newKeys = [...state.keys.slice(0, state.index + 1), key];
		set($navigationHistoryState, {
			keys: newKeys,
			index: newKeys.length - 1,
		});
	}
});
$trackNavigation.debugLabel = "trackNavigation";
